import { render, staticRenderFns } from "./SharedChat.vue?vue&type=template&id=5354e38e&"
import script from "./SharedChat.vue?vue&type=script&lang=js&"
export * from "./SharedChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports